import React from 'react';
import { V3 } from '../../api_request';
import { get } from 'lodash';

import CalloutEmbed from '../callout_embed';

interface Handpicked {
  name: string;
  href: string;
  image: string;
}

interface Props {
  slug: string;
  narrow?: boolean;
}

export default class HandpickedCalloutEmbed extends React.Component<Props, Handpicked> {
  constructor(props) {
    super(props);

    this.state = {
      name: null,
      href: null,
      image: null,
    };
  }

  componentDidMount() {
    const req = V3.get(`/api/curated_sets/${this.props.slug}/collection_header`);

    req.then((response) => {
      this.setState({
        name: response.title,
        href: get(response, '_links.web.href'),
        image: get(response, '_links.full_bleed_header_image.href'),
      });
    });
  }

  render() {
    if (!this.state.href) { return null; }

    return (
      <CalloutEmbed
        title={this.state.name}
        href={this.state.href}
        backgroundImage={this.state.image}
        narrow={this.props.narrow}
      />
    );
  }
}
